import { clientApiCall } from "./apiCallWrapper";

/**
 * Клиентский (браузерный) API пунктов выдачи СДЭК.
 * Ничего не знает о внешних бэкендах — ходит только в свой же Next.js BFF
 * (pages/api/client/sdek/*), который уже проксирует запрос к реальным сервисам.
 */
export default (_axios: any, config: any) => ({
  /**
   * Где вызывается: redux/action-creaters/cart.js → getSdekData(), диспатчится
   * из components/pages/personal/cart/useCartLogic.ts — страница /personal/cart/;
   * pages/delivery/index.js — страница /delivery/.
   * Также components/pages/checkoutOld/deliveryMap/sdekMap — этот компонент
   * сейчас не подключён ни к одной странице (мёртвый код).
   */
  getPoints(cityName: string, reset = false) {
    return clientApiCall(`${config.API_SERVER_URL}/client/sdek/getPoints/`, {
      api: "sdek.getPoints",
      // Нужен для выбора доставки при оформлении заказа — сообщаем о любом сбое
      critical: true,
      params: { cityName, reset },
    });
  },
  /**
   * Где вызывается: redux/action-creaters/cart.js → getSdekDataNew(),
   * диспатчится из components/pages/personal/cartNew/useCartLogic.ts —
   * страница /personal/cartNew/.
   */
  getPointsNew(cityName: string) {
    return clientApiCall(`${config.API_SERVER_URL}/client/sdek/getPointsNew/`, {
      api: "sdek.getPointsNew",
      // Нужен для выбора доставки при оформлении заказа — сообщаем о любом сбое
      critical: true,
      params: { cityName },
    });
  },
});
